<template>
  <el-dialog
    :visible.sync="innerVisible"
    :width="width"
    :fullscreen="fullscreen"
    :top="top"
    :modal="modal"
    :modal-append-to-body="modalAppendToBody"
    :append-to-body="appendToBody"
    :lock-scroll="lockScroll"
    :custom-class="mergedClass"
    :close-on-click-modal="closeOnClickModal"
    :close-on-press-escape="closeOnPressEscape"
    :destroy-on-close="destroyOnClose"
    :before-close="beforeClose || undefined"
    :center="false"
    :show-close="false"
    @open="handleOpen"
    @opened="handleOpened"
    @close="handleClose"
    @closed="handleClosed"
  >
    <div slot="title" class="app-dialog__header">
      <div class="app-dialog__title-wrap">
        <slot name="title">
          <div class="app-dialog__title">{{ title }}</div>
        </slot>
      </div>
      <button
        v-if="showClose"
        type="button"
        class="app-dialog__close"
        aria-label="关闭"
        @click="close"
      >
        <img :src="closeIcon" alt="关闭" />
      </button>
    </div>

    <div class="app-dialog__body">
      <slot />
    </div>

    <div v-if="$slots.footer" slot="footer" class="app-dialog__footer">
      <slot name="footer" />
    </div>
  </el-dialog>
</template>

<script>
import closeIcon from "@/assets/img/dialog-close.png";

export default {
  name: "Dialog",
  inheritAttrs: false,
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "50%"
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    top: {
      type: String,
      default: "15vh"
    },
    modal: {
      type: Boolean,
      default: true
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: ""
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    beforeClose: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      closeIcon
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    mergedClass() {
      return ["app-dialog", this.customClass].filter(Boolean).join(" ");
    }
  },
  methods: {
    close() {
      if (typeof this.beforeClose === "function") {
        this.beforeClose(() => {
          this.innerVisible = false;
        });
        return;
      }
      this.innerVisible = false;
    },
    handleOpen() {
      this.$emit("open");
    },
    handleOpened() {
      this.$emit("opened");
    },
    handleClose() {
      this.$emit("close");
    },
    handleClosed() {
      this.$emit("closed");
    }
  }
};
</script>

<style lang="less">
/* append-to-body 时需全局样式 */
.app-dialog {
  background: rgba(255, 255, 255, 0.95) !important;
  box-shadow: 0px 1px 20px 0px rgba(59, 130, 246, 0.3) !important;
  border-radius: 16px !important;
  border: 1px solid #ebf3ff !important;
  overflow: hidden;

  .el-dialog__header {
    padding: 20px 24px 12px;
    text-align: center;
    position: relative;
  }

  .el-dialog__body {
    padding: 12px 24px 20px;
  }

  .el-dialog__footer {
    padding: 12px 24px 20px;
    text-align: center;
  }
}

.app-dialog__header {
  position: relative;
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-dialog__title-wrap {
  width: 100%;
  padding: 0 36px;
  box-sizing: border-box;
  text-align: center;
}

.app-dialog__title {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #1f2a37;
  line-height: 28px;
  box-sizing: border-box;
}

.app-dialog__close {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;
  z-index: 2;

  img {
    width: 28px;
    height: 28px;
    display: block;
  }

  &:hover {
    opacity: 0.85;
  }
}

.app-dialog__body {
  min-height: 0;
}

.app-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog.vue